import styled from "styled-components"

export const RemoteTileRoot = styled.div`
    color: #fff;
    height: 100%;
    width: 100%;
`
